import { HoverCard } from "common/hovercards/HoverCard";
import React from "react";

export class MountOnHoverCard extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      hasBeenHovered: false,
    };
  }

  onMouseEnter = () => {
    this.setState({ hasBeenHovered: true });
  };

  render() {
    const { hasBeenHovered } = this.state;
    const { wrappedChildren, children } = this.props;

    return (
      <div onMouseEnter={this.onMouseEnter}>
        {wrappedChildren}
        {hasBeenHovered && (
          <HoverCard target={this} arrow theme="blueHeader">
            {children}
          </HoverCard>
        )}
      </div>
    );
  }
}
